import { ALERT_PRESET_BASES, ALERT_PRESET_OUTCOMES, toAlertType } from '~/packages/general/variable/spaceTime.data'

export interface AlertType {
  id: string
  name: string
}

export const ALERT_TYPES = {
  monthlyVariationYoY: {
    id: 'monthlyVariationYoY',
    name: 'Variação mensal (ano contra ano)',
  },
  currentMonthTrendYoY: {
    id: 'currentMonthTrendYoY',
    name: 'Tendência do mês atual (comparação anual)',
  },
  monthToMonthVariation: {
    id: 'monthToMonthVariation',
    name: 'Variação mês a mês',
  },
  currentMonthTrendMoM: {
    id: 'currentMonthTrendMoM',
    name: 'Tendência do mês atual (comparação sequencial)',
  },
  monthlyValueOutOfHistoricalPattern: {
    id: 'monthlyValueOutOfHistoricalPattern',
    name: 'Padrão histórico do valor mensal',
  },
  weeklyValueOutOfHistoricalPattern: {
    id: 'weeklyValueOutOfHistoricalPattern',
    name: 'Padrão histórico do valor semanal',
  },
  dailyValueOutOfHistoricalPattern: {
    id: 'dailyValueOutOfHistoricalPattern',
    name: 'Padrão histórico do valor diário',
  },
  accumulatedYearVariationYoY: {
    id: 'accumulatedYearVariationYoY',
    name: 'Variação acumulada do ano',
  },
  calendarPeriodComparisonDetection: {
    id: 'calendarPeriodComparisonDetection',
    name: 'Comparação de período equivalente',
  },
  calendarPeriodMADDetection: {
    id: 'calendarPeriodMADDetection',
    name: 'Desvio em período equivalente',
  },
  pairedTTestOutbreaksDetection: {
    id: 'pairedTTestOutbreaksDetection',
    name: 'Mudança estatisticamente relevante',
  },
  sparseDataDetection: {
    id: 'sparseDataDetection',
    name: 'Poucos dados',
  },
} as const

export const ALERT_BADGES_TYPES = {
  all: 'Todos',
  'with-good-alert': 'Com alertas bons',
  'with-bad-alert': 'Com alertas ruins',
  'with-alert': 'Com alerta',
  'without-alert': 'Sem alerta',
} as const

export const DEFAULT_ALERT_PRESET_FILTER = 'with-bad-alert' as const

export const ALERT_PRESET_FILTER_OPTIONS = [
  'all',
  'with-good-alert',
  'with-bad-alert',
  'with-alert',
  'without-alert',
  ...ALERT_PRESET_BASES.flatMap(base =>
    ALERT_PRESET_OUTCOMES.map(outcome => toAlertType(outcome, base)),
  ),
] as [string, ...string[]]

export const getAlertTypeName = (typeId: string | null): string => {
  if (!typeId) return 'Sem alerta'
  return ALERT_TYPES[typeId as keyof typeof ALERT_TYPES]?.name || `Tipo ${typeId}`
}

export const getAllAlertTypeOptions = (): Array<{ value: string; label: string }> => {
  return Object.values(ALERT_TYPES).map(alertType => ({
    value: alertType.id,
    label: alertType.name,
  }))
}
